export const NotificationTypeEnum = {
  BID_REQUEST: 'bidRequestCount',
  PRODUCT_FINDER: 'productFinderCount',
  CHAT: 'chatCount',
  SUPPORT: 'supportCount',
  BID_RESPONSES: 'bidResponsesCount',
}

export const NOTIFICATION_POLLING_INTERVAL = 1 * 60 * 1000 // 1 minute in milliseconds

export const NOTIFICATION_TYPES = {
  bidRequestCount: {
    key: 'bidRequestCount',
    message: (count) => `You have ${count} new bid request${count > 1 ? 's' : ''}`,
    routes: {
      customer: '/bids',
      retailer: '/retailer/product-requests',
      wholeseller: '/wholeseller/product-requests',
    },
    label: 'Bid Requests',
  },
  productFinderCount: {
    key: 'productFinderCount',
    message: (count) => `You have ${count} new product finder${count > 1 ? 's' : ''}`,
    routes: {
      customer: '/bids',
      retailer: '/retailer/products/requests',
      wholeseller: '/wholeseller/product-requests',
    },
    label: 'Product Finder',
  },
  chatCount: {
    key: 'chatCount',
    message: (count) => `You have ${count} new chat${count > 1 ? 's' : ''}`,
    routes: {
      customer: '/messages',
      retailer: '/messages',
      wholeseller: '/messages',
    },
    label: 'Messages',
  },
  bidResponsesCount: {
    key: 'bidResponsesCount',
    message: (count) => `You have ${count} new bid response${count > 1 ? 's' : ''}`,
    routes: {
      customer: '/bids',
    },
    label: 'Bid Responses',
  },
  productFinderResponsesCount: {
    key: 'productFinderResponsesCount',
    message: (count) => `You have ${count} new product finder response${count > 1 ? 's' : ''}`,
    routes: {
      customer: '/product-finder/responses',
    },
    label: 'Product Finder Responses',
  },
}

export const NOTIFICATION_STORAGE_KEY = 'notificationCounts'
